document.addEventListener('DOMContentLoaded', function() {
  const myAccountLink = document.querySelector('.my-account-link');
  const accountModal = document.querySelector('.account-modal');
  
  if (myAccountLink && accountModal) {
    // Toggle modal on click
    myAccountLink.addEventListener('click', function(e) {
      e.preventDefault();
      const isActive = accountModal.classList.toggle('active');
      
      // Toggle arrow rotation
      if (isActive) {
        myAccountLink.classList.add('active');
      } else {
        myAccountLink.classList.remove('active');
      }
    });
    
    // Close modal when clicking outside
    document.addEventListener('click', function(e) {
      if (!myAccountLink.contains(e.target) && !accountModal.contains(e.target)) {
        accountModal.classList.remove('active');
        myAccountLink.classList.remove('active');
      }
    });
  }
});

